/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { REQUEST_ADDRESS_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(REQUEST_ADDRESS_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((payload) =>
      AjaxRequest.open(
        'post',
        `/admin/contractcustom/contracts/${payload.id}/requestaddress`,
        payload,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
